/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from './auth0TokenApiDef';

type ParamsTypes = {
  client_id: string;
  client_secret: string;
  audience: string;
  grant_type: string;
};

const call = async (params: ParamsTypes): Promise<IFinalResponse> => {
  const result: IFinalResponse = {
    success: false,
    data: null,
    errors: undefined,
    metadata: null,
  };

  try {
    const init: InitApiType = {
      body: {
        ...params,
      },
    };
    const response = await post(
      Definitions.API_DOMAIN,
      Definitions.ENDPOINT_API_PATH,
      Definitions.API_CREDENTIALS_TYPE,
      init,
    );
    result.success = true;
    result.data = response.response;
  } catch (error) {
    result.success = false;
    result.data = null;
    result.errors = [error];
  }

  return result;
};

export default { call, definitions: Definitions };
